<template>
  <div class="main">
    <div
      v-for="(item, index) in list"
      :key="index"
      class="card_box"
      @click="toTaskDetails(item)"
    >
      <el-card shadow="hover">
        <div class="card-body">
          <div class="task_img" :class="`len-${item.works.length}`">
            <el-image
              v-for="(imgs, img_index) in item.works.length > 4
                ? item.works.slice(0, 4)
                : item.works"
              :key="img_index"
              fit="cover"
              :src="imgs.src"
            />
          </div>
          <!-- 课程详情展示 -->
          <div class="section_info">
            <!-- 作业缩略图 -->
            <div v-if="item.chapter_id" class="section_title">
              <div class="course">{{ item.course_name }}</div>
              <div class="chapter">{{ item.chapter_title }}</div>
            </div>
            <div v-else class="section_title">
              <div class="course">课外作业</div>
            </div>
            <div class="task_time">{{ item.create_time }}</div>
          </div>

          <div class="status">
            <div v-if="item.comment_status == 0">
              <span class="wait">等待点评</span>
            </div>
            <div v-if="item.comment_status == 1">
              <span class="spre">评分</span>
              <span
                class="score"
                :style="{ color: commentScoreColor(item.comment_score) }"
              >
                {{ item.comment_score }}</span
              >
            </div>
            <div v-if="item.comment_status == 2">
              <div class="reject">
                <icon-svg fill="#ff8b8b" icon-class="bohui" />
              </div>
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <!-- 分页按钮 -->
    <div class="pagination_box">
      <el-pagination
        layout="prev, pager, next"
        :page-size="pageInfo.pageLimt"
        :total="total"
        @current-change="changeCurrent"
      />
    </div>
  </div>
</template>

<script>
import { getWorkList } from '@/api/task'
export default {
  data() {
    return {
      list: null,
      pageInfo: {
        pageNum: 1,
        pageLimt: 8,
      },
      total: null,
    }
  },
  computed: {
    commentScoreColor() {
      return (s) => {
        if (s >= 80) {
          return '#07c160'
        } else if (s >= 60) {
          return '#ffb85c'
        } else {
          return '#ff7551'
        }
      }
    },
  },
  created() {
    this.getWorkList()
  },
  methods: {
    //页面变化
    changeCurrent(e) {
      this.pageInfo.pageNum = e
      this.getWorkList()
    },
    //页面数据请求
    async getWorkList() {
      const {
        data: { result },
      } = await getWorkList({
        page: this.pageInfo.pageNum,
        limit: this.pageInfo.pageLimt,
      })
      this.total = result.total
      this.list = result.data
      // console.log(this.list)
    },
    //作业详情页面
    toTaskDetails(item) {
      const { href } = this.$router.resolve({
        name: 'TASK_DETAILS',
        params: {
          id: item.id,
        },
      })
      window.open(href, '_blank')
    },
  },
}
</script>

<style scoped lang="scss">
.main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  padding: 0 10px;
  .card_box {
    padding: 18px 10px;
    // height: 220px;
    width: 50%;
    cursor: pointer;
    .el-card {
      height: 100%;
      border-radius: 4px;
      color: #828282;
      ::v-deep .el-card__body {
        padding: 15px;
      }
      .card-body {
        display: flex;
        .task_img {
          flex-shrink: 0;
          display: flex;
          flex-wrap: wrap;
          width: 80px;
          height: 80px;
          // border: 1px solid #eee;
          box-sizing: content-box;
          border-radius: 4px;
          overflow: hidden;
          margin-right: 10px;
          .el-image {
            border-radius: 2px;
          }
          &.len-1 {
            .el-image {
              margin: 1px;
              width: 78px;
              height: 78px;
            }
          }
          &.len-2 {
            .el-image {
              margin: 1px 1px 0 1px;
              width: 100%;
              height: 38px;
            }
          }
          &.len-3 {
            flex-direction: column;
            .el-image {
              width: 38px;
              height: 38px;
              margin-top: 1px;
              &:first-child {
                margin: 1px 1px 1px 1px;
                width: 38px;
                height: 100%;
              }
            }
          }
          &.len-4 {
            flex-direction: column;
            .el-image {
              width: 38px;
              height: 38px;
              margin: 1px 0 0 1px;
            }
          }
        }
        .section_info {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 3px 0;
          overflow: hidden;
          .section_title {
            .course {
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              font-size: 15px;
              font-weight: 600;
              margin-bottom: 4px;
              line-height: 1.2;
            }
            .chapter {
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              font-size: 13px;
            }
          }
          .task_time {
            font-size: 13px;
          }
        }
        .status {
          margin-left: 8px;
          display: flex;
          text-align: center;
          padding-top: 6px;
          .wait {
            padding: 1px 5px;
            border-radius: 4px;
            font-size: 12px;
            border: 1px solid #dfdfdf;
          }
          .spre {
            font-size: 12px;
            display: block;
            margin-bottom: 8px;
            opacity: 0.6;
          }
          .score {
            font-size: 25px;
            font-weight: 800;
          }
          .reject {
            width: 40px;
            font-size: 68px;
            text-align: right;
            transform: translate(-18px, -14px);
          }
        }
      }
    }
  }
  .pagination_box {
    width: 100%;
  }
}
</style>
